import { FormControl } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { clearParaphrase, selectParaphrase } from "@/store/qas/qasSlice";
import { selectPromptList } from "@/store/qas/qasPromptSlice";
import { useTranslate } from "@/hooks";
import { RequestStatus, ResponseStatus } from "@/types/statusTypes";
import DraggablePopoverComponent from "@/components/MUI/DraggablePopoverComponent/DraggablePopoverComponent";
import ParaphraseOption from "./ParaphraseOption/ParaphraseOption";
import CustomButton from "@/components/MUI/CustomButton/CustomButton";
import ProgressCircle from "@/components/MUI/ProgressCircle/ProgressCircle";
import { IParaphrasingProps } from "./Paraphrasing.props";
import styles from "./Paraphrasing.module.scss";

const Paraphrasing = ({ anchorForParaphrase, setAnchorForParaphrase, paraphraseHandler, sayOrConfirmationActionDataChangeHandler }: IParaphrasingProps): JSX.Element => {
	const dispatch = useAppDispatch();
	const promptList = useAppSelector(selectPromptList); // store - список промптов
	const paraphraseData = useAppSelector(selectParaphrase); // store - перефразирование

	const translate = useTranslate(); // hook для перевода текста

	return (
		<DraggablePopoverComponent
			anchorEl={anchorForParaphrase}
			setAnchorEl={setAnchorForParaphrase}
			closeHandler={() => {
				dispatch(clearParaphrase());
			}}
			disableDefaultCloseButton
			sx={{ minWidth: "400px" }}
		>
			{/* список шаблонов */}
			{Array.isArray(promptList.data) &&
				promptList.data.filter((promptItem) => promptItem.type === "similars_generator").length > 1 &&
				promptList.data
					.filter((promptItem) => promptItem.type === "similars_generator")
					.map(({ id, name }) => (
						<div className={styles.promptItem} key={id} onClick={() => paraphraseHandler(id)}>
							{name}
						</div>
					))}

			{/* загрузка */}
			{paraphraseData.status === RequestStatus.LOADING && (
				<div>
					<ProgressCircle title={translate("title_paraphrasing")} />
				</div>
			)}

			{/* ошибка */}
			{(paraphraseData.status === RequestStatus.FAILED || paraphraseData.error === ResponseStatus.FAILED) && (
				<div>{translate(paraphraseData.message || "title_loadFailed")}</div>
			)}

			{/* результат перефразирования */}
			{paraphraseData.status === RequestStatus.IDLE && paraphraseData.data && (
				<div>
					{paraphraseData.data.map((text, idx, textArray) => (
						<ParaphraseOption key={text} text={text} idx={idx} textArray={textArray} />
					))}

					{/* добавить */}
					<FormControl fullWidth margin="dense">
						<CustomButton
							type="button"
							disabled={paraphraseData.data.length === 0}
							onClick={() => {
								paraphraseData.data && sayOrConfirmationActionDataChangeHandler({ operation: "add", text: paraphraseData.data });
								setAnchorForParaphrase(null);
								dispatch(clearParaphrase());
							}}
						>
							{translate("button_add")}
						</CustomButton>
					</FormControl>
				</div>
			)}
		</DraggablePopoverComponent>
	);
};

export default Paraphrasing;
